// Real PDF generation from a DOM node (no print dialog).
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export const slugify = (s) =>
  String(s || 'document').trim().replace(/[^a-zA-Z0-9-_]+/g, '-').replace(/^-|-$/g, '');

export const buildPdfBlob = async (el) => {
  if (!el) throw new Error('Nothing to export');
  const canvas = await html2canvas(el, {
    scale: 2,
    backgroundColor: '#ffffff',
    useCORS: true,
    logging: false,
    windowWidth: el.scrollWidth,
  });

  const pdf = new jsPDF({ unit: 'pt', format: 'a4', compress: true });
  const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();
  const margin = 28;
  const imgW = pageW - margin * 2;
  const imgH = (canvas.height * imgW) / canvas.width;
  const data = canvas.toDataURL('image/jpeg', 0.95);

  const usableH = pageH - margin * 2;
  if (imgH <= usableH) {
    pdf.addImage(data, 'JPEG', margin, margin, imgW, imgH);
  } else {
    let offset = 0;
    let page = 0;
    while (offset < imgH - 2) {
      if (page > 0) pdf.addPage();
      pdf.addImage(data, 'JPEG', margin, margin - offset, imgW, imgH);
      // mask overflow outside the page body
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageW, margin, 'F');
      pdf.rect(0, pageH - margin, pageW, margin, 'F');
      offset += usableH;
      page += 1;
    }
  }
  return pdf.output('blob');
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 4000);
};

export const downloadPdf = async (el, filename) => {
  const blob = await buildPdfBlob(el);
  downloadBlob(blob, filename);
  return blob;
};

export const canSharePdfFile = () => {
  if (typeof navigator === 'undefined' || !navigator.canShare) return false;
  try {
    const probe = new File([new Blob(['x'], { type: 'application/pdf' })], 'a.pdf', { type: 'application/pdf' });
    return navigator.canShare({ files: [probe] });
  } catch (e) {
    return false;
  }
};

export const sharePdfFile = async (el, filename, { title, text } = {}) => {
  const blob = await buildPdfBlob(el);
  const file = new File([blob], filename, { type: 'application/pdf' });
  await navigator.share({ files: [file], title, text });
};
